import React from 'react'
import { Button, ModalV2, Dialog } from 'stylist'
import DangerDropdownMenuItem from 'components/DangerDropdownMenuItem'

const RemoveUserModal = ({ user, group, open, onDelete, onClose }) => (
  <ModalV2
    render={({ hide }) => (
      <Dialog>
        <Dialog.Header>
          <Dialog.Title>Remove user</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          Are you sure you want to remove <em>{user.email}</em> from{' '}
          <em>{group.name}</em>? Performing this action will disable any enabled
          features in this group for this user.
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.CancelButton onClose={hide} />
          <Button kind="danger" onClick={onDelete}>
            Remove user
          </Button>
        </Dialog.Footer>
      </Dialog>
    )}
  >
    {({ show }) => (
      <DangerDropdownMenuItem to="#" onClick={show}>
        Remove user
      </DangerDropdownMenuItem>
    )}
  </ModalV2>
)

export default RemoveUserModal



// WEBPACK FOOTER //
// ./src/routes/admin/features/group/components/RemoveUserModal.js